@if (messageCenterIcon()) {
<div class="message-center-container" id="message-center-entry">
  <div
    (click)="toggleMenu()"
    (keydown.enter)="toggleMenu()"
    [attr.tabindex]="0"
    class="message-center-trigger"
  >
    <img 
      [src]="getMessageCenterIcon()
      "
      alt="Message Center Icon"
      class="message-center-icon"
      loading="lazy"
    />
  </div>
</div>
}

<!-- Profile Navigation -->
@if (isProfileNav()) {
  <button
    id="item-Message-Center"
    role="menuitem"
    [tabindex]="menuOpen ? 0 : -1"
    class="nav-message-outer"
     (click)="toggleMenu()"
    (keydown.enter)="toggleMenu()"
  >
    <span class="highlight__content" tabindex="-1">{{ myMessagesText() }} </span>
    @if (areNewMessages) {
    <span class="nav-unread-count" >{{
      unReadMessagesCount
    }}</span>
  }
  </button>
}

